
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iyIyT", function(module, exports) {

$parcel$export(module.exports, "AISummaryStreamingState", () => $c16bce224d83709b$export$93af043be4836651);
var $c16bce224d83709b$export$93af043be4836651 = /*#__PURE__*/ function(AISummaryStreamingState) {
    AISummaryStreamingState["Initialization"] = "Initialization";
    AISummaryStreamingState["AnswerPart"] = "AnswerPart";
    AISummaryStreamingState["FinalResponse"] = "FinalResponse";
    AISummaryStreamingState["FollowUp"] = "FollowUp";
    AISummaryStreamingState["Error"] = "Error";
    return AISummaryStreamingState;
}({});

});

parcelRegister("lL1Cj", function(module, exports) {

$parcel$export(module.exports, "useAISummaryStreaming", () => $407aa891086c405a$export$4bde2604d76545ee);

var $guQFZ = parcelRequire("guQFZ");

var $eJ5lO = parcelRequire("eJ5lO");

var $4iZtC = parcelRequire("4iZtC");

var $7CiAC = parcelRequire("7CiAC");

var $eByKY = parcelRequire("eByKY");

var $1HDbh = parcelRequire("1HDbh");

var $kkxph = parcelRequire("kkxph");

var $3CH4j = parcelRequire("3CH4j");

var $8EEqM = parcelRequire("8EEqM");

var $d7x0s = parcelRequire("d7x0s");
var $92kN7 = parcelRequire("92kN7");
var $89BX5 = parcelRequire("89BX5");

var $iyIyT = parcelRequire("iyIyT");

var $hbElZ = parcelRequire("hbElZ");
var $5zeW3 = parcelRequire("5zeW3");
const $407aa891086c405a$var$memoAISummaryStreamingState = (aiSummaryConfigPrev, aiSummaryConfigPrevNext)=>{
    if ('ari' in aiSummaryConfigPrev && 'ari' in aiSummaryConfigPrevNext) return aiSummaryConfigPrev.ari === aiSummaryConfigPrevNext.ari;
    if ('url' in aiSummaryConfigPrev && 'url' in aiSummaryConfigPrevNext) return aiSummaryConfigPrev.url === aiSummaryConfigPrevNext.url;
    return false;
};
function $407aa891086c405a$export$4bde2604d76545ee(config, initialState = {
    content: '',
    state: (0, $iyIyT.AISummaryStreamingState).Initialization
}) {
    const { onStart: onStart, onStreamStart: onStreamStart, onProgress: onProgress, onError: onError, onDone: onDone, delayChunkUpdate: delayChunkUpdate, withRefetch: withRefetch } = config;
    const aiSummaryStreamingState$ = (0, $hbElZ.useObservable)((inputs$)=>inputs$.pipe((0, $7CiAC.distinctUntilChanged)(([aiSummaryConfigPrev], [aiSummaryConfigPrevNext])=>$407aa891086c405a$var$memoAISummaryStreamingState(aiSummaryConfigPrev, aiSummaryConfigPrevNext)), (0, $eByKY.map)(([aiSummaryConfig, initialState])=>({
                aiSummaryConfig: aiSummaryConfig,
                initialState: initialState,
                requestUrl: (0, $89BX5.mapToURL)(aiSummaryConfig)
            })), (0, $eByKY.map)(({ aiSummaryConfig: aiSummaryConfig, initialState: initialState, requestUrl: requestUrl })=>({
                requestOptions: (0, $92kN7.mapToAIAgentRequest)(aiSummaryConfig, requestUrl),
                initialState: initialState
            })), (0, $kkxph.switchMap)(({ requestOptions: requestOptions, initialState: initialState })=>{
            onStart?.();
            return (0, $d7x0s.makeAIAgentStreamRequest)(requestOptions, initialState);
        }), (0, $8EEqM.timeInterval)(), (0, $eJ5lO.concatMap)((nextState)=>{
            if (!delayChunkUpdate) return (0, $guQFZ.of)(nextState.value);
            const { time: time, gap: gap } = delayChunkUpdate;
            if (nextState.interval < gap) return (0, $guQFZ.of)(nextState.value).pipe((0, $4iZtC.delay)(time));
            return (0, $guQFZ.of)(nextState.value);
        }), (0, $3CH4j.tap)(({ state: state, answerChunkIndex: answerChunkIndex, error: error })=>{
            switch(state){
                case (0, $iyIyT.AISummaryStreamingState).AnswerPart:
                    if (answerChunkIndex === 0) onStreamStart?.();
                    onProgress?.();
                    break;
                case (0, $iyIyT.AISummaryStreamingState).FinalResponse:
                    onDone?.();
                    break;
                case (0, $iyIyT.AISummaryStreamingState).Error:
                    onError?.(error);
            }
        })), [
        config,
        initialState
    ]);
    const [state, refetch] = (0, $5zeW3.useObservableState)((aiSummarySubject$)=>aiSummarySubject$.pipe((0, $1HDbh.startWith)(initialState), (0, $kkxph.switchMap)(()=>aiSummaryStreamingState$)), {
        ...initialState
    });
    if (withRefetch) return [
        state,
        refetch
    ];
    return state;
}

});
parcelRegister("d7x0s", function(module, exports) {

$parcel$export(module.exports, "makeAIAgentStreamRequest", () => $f9052ebc240ffef1$export$f08c4fd1705b0192);

var $iX7e9 = parcelRequire("iX7e9");

var $iyIyT = parcelRequire("iyIyT");

var $c8LjI = parcelRequire("c8LjI");
const $f9052ebc240ffef1$export$f08c4fd1705b0192 = ({ requestUrl: requestUrl, requestOptions: requestOptions, featureFlags: featureFlags = {} }, initialState)=>{
    const behaviorSubject = new (0, $iX7e9.BehaviorSubject)({
        ...initialState
    });
    fetch(requestUrl, {
        credentials: 'include',
        ...requestOptions
    }).then((response)=>(0, $c8LjI.readStream)(response)).then(async (stream)=>{
        let bufferContent = '';
        let answerChunkIndex = 0;
        for await (const chunk of stream){
            const state = behaviorSubject.getValue();
            switch(chunk.type){
                case 'ANSWER_PART':
                    bufferContent += chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        state: (0, $iyIyT.AISummaryStreamingState).AnswerPart,
                        content: bufferContent,
                        answerChunkIndex: answerChunkIndex
                    });
                    answerChunkIndex += 1;
                    break;
                case 'FINAL_RESPONSE':
                    bufferContent = chunk.message.message.content;
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        state: (0, $iyIyT.AISummaryStreamingState).FinalResponse,
                        content: bufferContent
                    });
                    break;
                case 'FOLLOW_UP_QUERIES':
                    if (!featureFlags?.showFollowUps) return;
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        followUpContent: chunk.message.follow_ups ?? [],
                        state: (0, $iyIyT.AISummaryStreamingState).FollowUp
                    });
                    break;
                case 'ERROR':
                    behaviorSubject.next({
                        ...state,
                        answerChunkIndex: undefined,
                        state: (0, $iyIyT.AISummaryStreamingState).Error,
                        error: {
                            ...chunk
                        }
                    });
                    break;
            }
        }
    }).finally(()=>{
        behaviorSubject.complete();
    });
    return behaviorSubject;
};

});
parcelRegister("c8LjI", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $063fa47b2ffd0ad9$export$e45226161c660403);

var $bddW2 = parcelRequire("bddW2");

var $agEvB = parcelRequire("agEvB");
async function* $063fa47b2ffd0ad9$export$e45226161c660403(response) {
    // covered HTTP errors only from this doc
    // https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3420210503/Error+message+formats+-+assistance-service
    const possibleHTTPError = await (0, $bddW2.match)(response).returnType().with({
        status: 201
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: No answer was generated by Open AI. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $agEvB.ErrorMessage).NO_ANSWER,
                status_code: response.status
            }
        };
    }).with({
        status: 400
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: BAD_REQUEST or NO_AGENT or EXCEEDING_CONTEXT_LENGTH_ERROR. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $agEvB.ErrorMessage).NO_AGENT,
                status_code: response.status
            }
        };
    }).with({
        status: 403
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: FEATURE_DISABLED_ON_SITE or FEATURE_DISABLED or HIPAA_CONTENT_DETECTED. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $agEvB.ErrorMessage).AI_DISABLED,
                status_code: response.status
            }
        };
    }).with({
        status: 429
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: RATE_LIMIT or OPENAI_RATE_LIMIT_USER_ABUSE. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $agEvB.ErrorMessage).RATE_LIMIT,
                status_code: response.status
            }
        };
    }).with({
        status: 500
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: INTERNAL_SERVER_ERROR. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $agEvB.ErrorMessage).UNEXPECTED,
                status_code: response.status
            }
        };
    }).with({
        status: (0, $bddW2.P).not(200)
    }, async ()=>{
        const responseText = await response.text();
        return {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: OTHER_SERVER_ERROR. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $agEvB.ErrorMessage).UNEXPECTED,
                status_code: response.status
            }
        };
    }).otherwise(()=>Promise.resolve(null));
    if (possibleHTTPError) {
        yield possibleHTTPError;
        return;
    }
    if (!response.body) {
        const responseText = await response.text();
        yield {
            type: 'ERROR',
            message: {
                content: `[Error]: response.body is missing. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $agEvB.ErrorMessage).NETWORK_ERROR,
                status_code: response.status
            }
        };
        return;
    }
    try {
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        let done = false;
        while(!done){
            const { value: value, done: doneReading } = await reader.read();
            const decodedValue = decoder.decode(value);
            done = doneReading;
            buffer = `${buffer}${decodedValue}`;
            // Split the buffer by line breaks
            const lines = buffer.split('\n');
            // Process all complete lines, except for the last one (which might be incomplete)
            while(lines.length > 1){
                const line = lines.shift();
                const parsedData = JSON.parse(line);
                yield parsedData;
            }
            // Keep the last (potentially incomplete) line in the buffer
            buffer = lines[0];
        }
        return;
    } catch (parsingError) {
        let errorText = '';
        if (typeof parsingError === 'string') errorText = parsingError.toUpperCase();
        else if (parsingError instanceof Error) errorText = parsingError.message;
        yield {
            type: 'ERROR',
            message: {
                content: `[Stream Error]: ${errorText}. locked status: ${response.body.locked}. statusCode: ${response.status}`,
                message_template: (0, $agEvB.ErrorMessage).UNEXPECTED
            }
        };
        return;
    }
}

});


parcelRegister("92kN7", function(module, exports) {

$parcel$export(module.exports, "mapToAIAgentRequest", () => $96f8f0852628c5c9$export$f9ad2230f0827c88);
function $96f8f0852628c5c9$export$f9ad2230f0827c88(aiSummaryStreamingConfig, requestUrl) {
    const { headers: headers, agentNamedId: agentNamedId, locale: locale, agentPrompt: agentPrompt, experienceId: experienceId, product: product, summaryOutputMimetype: summaryOutputMimetype, summaryStyle: summaryStyle, ari: ari, promptId: promptId, featureFlags: featureFlags, updateType: updateType, jsonStructured: jsonStructured, outputMimetype: outputMimetype, endTimeMs: endTimeMs, cloudId: cloudId, selectedVersions: selectedVersions } = aiSummaryStreamingConfig;
    const payload = {
        recipient_agent_named_id: agentNamedId,
        agent_input_prompt: agentPrompt,
        agent_input_context: {
            content_ari: ari,
            summary_style: summaryStyle,
            prompt_id: promptId,
            update_type: updateType,
            locale: locale,
            ...summaryOutputMimetype ? {
                summary_output_mimetype: summaryOutputMimetype
            } : {},
            ...outputMimetype ? {
                output_mimetype: outputMimetype
            } : {},
            json_structured: jsonStructured,
            ...endTimeMs ? {
                end_time_ms: endTimeMs
            } : {},
            ...selectedVersions || {}
        }
    };
    if ('url' in aiSummaryStreamingConfig) {
        // Send URL even if ari is present as it can be used as a fallback
        const { url: url } = aiSummaryStreamingConfig;
        payload.agent_input_context.content_url = url;
    }
    const requestHeaders = new Headers({
        'content-type': 'application/json;charset=UTF-8',
        'x-experience-id': experienceId,
        'x-product': product,
        ...headers
    });
    if (cloudId) requestHeaders.set('x-cloudid', cloudId);
    const requestOptions = {
        method: 'POST',
        headers: requestHeaders,
        body: JSON.stringify(payload)
    };
    return {
        requestUrl: requestUrl,
        requestOptions: requestOptions,
        featureFlags: featureFlags
    };
}

});

parcelRegister("89BX5", function(module, exports) {

$parcel$export(module.exports, "mapToURL", () => $0cd86d8ed4a7e434$export$eeb0f71528628f71);

var $hcD0d = parcelRequire("hcD0d");
function $0cd86d8ed4a7e434$export$eeb0f71528628f71(aiSummaryStreamingConfig, streaming = true) {
    const { baseUrl: baseUrl } = aiSummaryStreamingConfig;
    const baseStreamURL = baseUrl ?? (0, $hcD0d.BASE_STREAM_URL);
    const chatPath = streaming ? (0, $hcD0d.CHAT_STREAM_PATH) : (0, $hcD0d.CHAT_PATH);
    const requestUrl = `${baseStreamURL}/${chatPath}`;
    return requestUrl;
}

});
parcelRegister("hcD0d", function(module, exports) {

$parcel$export(module.exports, "CHAT_STREAM_PATH", () => $ceca5b6d907f1cd0$export$82796cc300bdfa9d);
$parcel$export(module.exports, "CHAT_PATH", () => $ceca5b6d907f1cd0$export$54306dc3a5fddc77);
$parcel$export(module.exports, "BASE_STREAM_URL", () => $ceca5b6d907f1cd0$export$7c03f5942efb8a41);
const $ceca5b6d907f1cd0$export$82796cc300bdfa9d = 'chat/v1/invoke_agent/stream';
const $ceca5b6d907f1cd0$export$54306dc3a5fddc77 = 'chat/v1/invoke_agent';
const $ceca5b6d907f1cd0$export$7c03f5942efb8a41 = '/gateway/api/assist';

});


parcelRegister("hbElZ", function(module, exports) {

$parcel$export(module.exports, "useObservable", () => $5f64958511fe1beb$export$262b072b280a540c);
/**
 * @license observable-hooks
 * index.ts
 *
 * Copyright (c) 2023 CRIMX<straybugs@gmail.com>
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable react-hooks/rules-of-hooks */ 
var $gwFzn = parcelRequire("gwFzn");

var $iX7e9 = parcelRequire("iX7e9");
/**
 * @template TOutput Output value within Observable.
 * @template TInputs A readonly tuple of all dependencies.
 *
 * @param useCustomEffect useEffect or useLayoutEffect
 * @param init A pure function that, when applied to an Observable,
 * returns an Observable.
 * @param inputs An dependency array with fixed length. When one of the dependencies
 * changes the Observable in `init` will emit an array of all the dependencies.
 */ function $5f64958511fe1beb$var$useObservableInternal(init, inputs) {
    // Even though hooks are under conditional block
    // it is for a completely different use case
    // which unlikely coexists with the other one.
    // A warning is also added to the docs.
    if (!inputs) return (0, $gwFzn.useState)(init)[0];
    const [inputs$] = (0, $gwFzn.useState)(()=>new (0, $iX7e9.BehaviorSubject)(inputs));
    const [source$] = (0, $gwFzn.useState)(()=>init(inputs$));
    const firstEffectRef = (0, $gwFzn.useRef)(true);
    (0, $gwFzn.useEffect)(()=>{
        if (firstEffectRef.current) {
            firstEffectRef.current = false;
            return;
        }
        inputs$.next(inputs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
    return source$;
}
function $5f64958511fe1beb$export$262b072b280a540c(init, inputs) {
    return $5f64958511fe1beb$var$useObservableInternal(init, inputs);
}

});

parcelRegister("5zeW3", function(module, exports) {

$parcel$export(module.exports, "useObservableState", () => $c2a30628d915f915$export$561674a65351b693);
/**
 * @license observable-hooks
 * index.ts
 *
 * Copyright (c) 2023 CRIMX<straybugs@gmail.com>
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable react-hooks/rules-of-hooks */ 
var $gwFzn = parcelRequire("gwFzn");

var $iX7e9 = parcelRequire("iX7e9");

var $2Ixil = parcelRequire("2Ixil");

var $81DRH = parcelRequire("81DRH");

var $1Kwkp = parcelRequire("1Kwkp");
function $c2a30628d915f915$export$561674a65351b693(state$OrInit, initialState) {
    // Even though hooks are under conditional block
    // it is for a completely different use case
    // which unlikely coexists with the other one.
    // A warning is also added to the docs.
    if ((0, $81DRH.isObservable)(state$OrInit)) {
        const state$ = state$OrInit;
        const [state, setState] = (0, $gwFzn.useState)(()=>{
            if (state$ instanceof (0, $iX7e9.BehaviorSubject) || state$.value !== undefined) return state$.value;
            if (typeof initialState === 'function') return initialState();
            return initialState;
        });
        (0, $1Kwkp.useSubscription)(state$, setState);
        (0, $gwFzn.useDebugValue)(state);
        return state;
    } else {
        const init = state$OrInit;
        const [state, setState] = (0, $gwFzn.useState)(initialState);
        const [input$] = (0, $gwFzn.useState)((0, $2Ixil.getEmptySubject));
        const [state$] = (0, $gwFzn.useState)(()=>init(input$, state));
        const callback = (0, $gwFzn.useRef)((state)=>input$.next(state)).current;
        (0, $1Kwkp.useSubscription)(state$, setState);
        (0, $gwFzn.useDebugValue)(state);
        return [
            state,
            callback
        ];
    }
}

});
parcelRegister("2Ixil", function(module, exports) {

$parcel$export(module.exports, "getEmptySubject", () => $f9ef89eea28f6a31$export$515c0fda29e99c0d);

var $cC77I = parcelRequire("cC77I");
const $f9ef89eea28f6a31$export$515c0fda29e99c0d = ()=>new (0, $cC77I.Subject)();

});

parcelRegister("81DRH", function(module, exports) {

$parcel$export(module.exports, "isObservable", () => $15d1c4c89f3eed98$export$5cd057a6046189f9);

var $7Qfu8 = parcelRequire("7Qfu8");
const $15d1c4c89f3eed98$export$5cd057a6046189f9 = (obj)=>obj instanceof (0, $7Qfu8.Observable);

});

parcelRegister("1Kwkp", function(module, exports) {

$parcel$export(module.exports, "useSubscription", () => $d21f8f3e14380598$export$368b4214baeb914c);
/**
 * @license observable-hooks
 * index.ts
 *
 * Copyright (c) 2023 CRIMX<straybugs@gmail.com>
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $bLfXj = parcelRequire("bLfXj");
const $d21f8f3e14380598$var$toObserver = (args)=>args[1]?.next ? args[1] : {
        next: args[1],
        error: args[2],
        complete: args[3]
    };
/**
 *
 * @template TInput Input value within Observable.
 *
 * @param useCustomEffect useEffect or useLayoutEffect
 * @param args collected arguments
 */ function $d21f8f3e14380598$var$useSubscriptionInternal(args) {
    const argsRef = (0, $gwFzn.useRef)(args);
    const observerRef = (0, $gwFzn.useRef)();
    const subscriptionRef = (0, $gwFzn.useRef)();
    const deps = args[0];
    // Update the latest observable and callbacks
    // synchronously after render being committed
    (0, $bLfXj.useIsomorphicLayoutEffect)(()=>{
        argsRef.current = args;
        observerRef.current = $d21f8f3e14380598$var$toObserver(args);
    });
    (0, $gwFzn.useEffect)(()=>{
        // keep in closure for checking staleness
        const input$ = argsRef.current[0];
        /* istanbul ignore if: Just in case the layoutEffect order is agnostic */ if (!observerRef.current) observerRef.current = $d21f8f3e14380598$var$toObserver(argsRef.current);
        const subscription = input$.subscribe({
            next: (value)=>{
                if (input$ === argsRef.current[0]) observerRef.current.next?.(value);
            // else: stale observable
            },
            error: (error)=>{
                if (input$ === argsRef.current[0]) observerRef.current.error ? observerRef.current.error(error) : console.error(error);
            // else: stale observable
            },
            complete: ()=>{
                if (input$ === argsRef.current[0]) observerRef.current.complete?.();
            // else: stale observable
            }
        });
        subscriptionRef.current = subscription;
        return ()=>{
            subscription.unsubscribe();
        };
    }, [
        deps
    ]);
    return subscriptionRef;
}
function $d21f8f3e14380598$export$368b4214baeb914c(input$, observerOrNext$, error, complete) {
    return $d21f8f3e14380598$var$useSubscriptionInternal([
        input$,
        observerOrNext$,
        error,
        complete
    ]);
}

});
parcelRegister("bLfXj", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $fe769f18701d2af2$export$700979bc83e7db82);
/**
 * @license observable-hooks
 * index.ts
 *
 * Copyright (c) 2023 CRIMX<straybugs@gmail.com>
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $gwFzn = parcelRequire("gwFzn");
const $fe769f18701d2af2$export$700979bc83e7db82 = /* @__PURE__ */ (()=>/* istanbul ignore next */ typeof window === 'undefined' ? (0, $gwFzn.useEffect) : (0, $gwFzn.useLayoutEffect))();

});





//# sourceMappingURL=QuickSummaryStreamingEntryPoint.36c2fcfb.js.map
